import { FillInTableError } from "../fillInTableError";

export class NotCorrectDataFormatError extends FillInTableError {
  constructor(errorData?: string[]) {
    const isErrorData = errorData && errorData.length > 0;
    super(isErrorData ? ` - ${errorData?.join("\n - ")}` : "");
  }
}
